import ReactDOM from "react-dom";
import React from "react";
import { FaStackOverflow } from "react-icons/fa";
export const Modal = ({ modalHeading, modalMessage, onClick }) => {

    const modalOverlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding:"20px"
      };
    
      const modalContentStyle = {
        background: "white",
        padding: "20px",
        borderRadius: "8px",
        textAlign: "center",
         maxWidth: "500px",
        maxHeight:"480px",
        overflow:"hidden",
        overflowY:"auto"

      };
    
      const closeButtonStyle = {
        background: "#07b1b0",
        color: "white",
        border: "none",
        padding: "10px",
        borderRadius: "5px",
        marginTop: "10px",
        cursor: "pointer",
      };
      

    return ReactDOM.createPortal(
              <div style={modalOverlayStyle}>
                <div style={modalContentStyle}>
                <h2 style={{ margin: "10px 0" }}>{modalHeading !== undefined ? modalHeading : "Validation Result"}</h2>
                  <p style={{ textAlign: "left",fontWeight:"bold" }}>{modalMessage}</p>
                  <button style={closeButtonStyle} onClick={onClick}>
                    Close
                  </button>
                </div>
              </div>,
              document.body // Moves modal outside the component tree
            )
};